module.exports = "/assets/e5c9e37854b6fe0260344aab37fa9961.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/V7.png
// module id = 3035
// module chunks = 0